import { render, staticRenderFns } from "./AmountChip.vue?vue&type=template&id=4db27b8d&scoped=true&"
import script from "./AmountChip.vue?vue&type=script&lang=ts&"
export * from "./AmountChip.vue?vue&type=script&lang=ts&"
import style0 from "./AmountChip.vue?vue&type=style&index=0&id=4db27b8d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db27b8d",
  null
  
)

export default component.exports